import Vuex from 'vuex'
import VuexPersistedState from 'vuex-persistedstate'

export default new Vuex.Store({
    plugins: [
        VuexPersistedState({
            paths: [
                "token",
                "user",
                "locale",
                "isProductsListView"
            ]
        })
    ],
    state: {
        token: null,
        user: null,
        locale: 'fr',
        openInvoice: null,
        distributions: null,
        pickupLocations: [],
        isAppBarExtended: false,
        isProductsListView: false,
        distributionStatusText: ''
    },
    getters: {
        isDistributionOpen(state) {
            if (!state.distributions) {
                return false;
            }
            return state.distributions.open !== null;
        },
        isDistributionOpenOrBeforeDelivery(state) {
            if (!state.distributions) {
                return false;
            }
            return state.distributions.openOrBeforeDelivery !== null;
        }
    },
    mutations: {
        setToken: function (state, token) {
            state.token = token
            if (!token) {
                state.user = null;
            }
        },
        setUser: function (state, user) {
            state.user = user;
        },
        setLocale: function (state, locale) {
            if (state.locale === locale) {
                return
            }
            state.locale = locale;
            location.reload();
        },
        setOpenInvoice: function (state, openInvoice) {
            state.openInvoice = openInvoice
        },
        setDistributions: function (state, distributions) {
            state.distributions = distributions
        },
        setPickupLocations: function(state, pickupLocations) {
            state.pickupLocations = pickupLocations;
        },
        setIsAppBarExtended: function (state, isAppBarExtended) {
            state.isAppBarExtended = isAppBarExtended
        },
        setIsProductsListView: function (state, isProductsListView) {
            state.isProductsListView = isProductsListView
        },
        setDistributionStatusText: function (state, text) {
            state.distributionStatusText = text
        }
    },
    actions: {
        setToken: function (action, token) {
            action.commit('setToken', token)
        },
        setUser: function (action, user) {
            action.commit('setUser', user)
        },
        setLocale: function (action, locale) {
            action.commit('setLocale', locale)
        },
        setOpenInvoice: function (action, openInvoice) {
            if (openInvoice === undefined) {
                openInvoice = null
            }
            action.commit('setOpenInvoice', openInvoice)
        },
        setDistributions: function (action, distributions) {
            if (distributions === undefined || distributions === null) {
                distributions = {}
            }
            action.commit('setDistributions', distributions)
        },
        setPickupLocations: function (action, pickupLocations) {
            if (pickupLocations === undefined || pickupLocations === null) {
                pickupLocations = []
            }
            action.commit('setPickupLocations', pickupLocations)
        },
        setIsAppBarExtended: function (action, isAppBarExtended) {
            action.commit('setIsAppBarExtended', isAppBarExtended)
        },
        setIsProductsListView: function (action, isProductsListView) {
            action.commit('setIsProductsListView', isProductsListView)
        },
        setDistributionStatusText: function (action, text) {
            action.commit('setDistributionStatusText', text)
        }
    }
})
